import * as React from 'react';

export interface ServiceWorkOrderCompleteProps {
  readonly serviceWorkOrderId: number;
  readonly alternateText?: string;
}

export class ServiceWorkOrderCompleteComponent extends React.Component<ServiceWorkOrderCompleteProps> {
  render() {
    return (
      <div className="row middle-xs center-xs">
        {this.props.alternateText ? (
          <h2>{this.props.alternateText}</h2>
        ) : (
          <h2>
            Payment information has been submitted and a copy of Service Work Order # {this.props.serviceWorkOrderId}{' '}
            and its declarations has been emailed to the initiating contact.
          </h2>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/service-work-order/_components/service-work-order-create/service-fee-payment-step/service-work-order-complete.component.tsx